module.exports = __webpack_public_path__ + "assets/img/944d-gi.svg";